import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ovoData: {
    phoneNoOvo: '',
  },
  atomeData: {
    phoneNoAtome: '',
  },
};

const eWalletSlice = createSlice({
  name: 'E_WALLET',
  initialState,
  reducers: {
    RESET_EWALLET_DATA(state) {
      state.ovoData = {
        phone_number: '',
      };
      state.atomeData = {
        phone_number: '',
      };
    },
    SET_EWALLET_OVO_DATA(state, { data }) {
      state.ovoData = { ...state.ovoData, ...data };
    },
    SET_EWALLET_ATOME_DATA(state, { data }) {
      state.atomeData = { ...state.atomeData, ...data };
    },
  },
});

export const {
  RESET_EWALLET_DATA,
  SET_EWALLET_OVO_DATA,
  SET_EWALLET_ATOME_DATA,
} = eWalletSlice.actions;
export default eWalletSlice.reducer;
